import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

/** 1. GET the Master Operations eligible for a new approval limit (already-configured ones are excluded) */
export const getApprLimitWorkflows = () =>
    axios.get(`${base}/Accounts/GETApprLimtWorkflows`);

/** 2. GET all configured approval limits (grid) */
export const getAllApprovalLimits = () =>
    axios.get(`${base}/Accounts/GetAllApprovalLimits`);

/** 3. POST add/update/delete an approval limit — distinguished by the `Action` field ('Add' | 'Update' | 'Delete') */
export const saveApprovalLimit = ({ LimitId, MoId, Amount, CreatedBy, Action, RoleId }) =>
    axios.post(`${base}/Accounts/SaveApprovalLimit`, { LimitId, MoId, Amount, CreatedBy, Action, RoleId });
